import {jqGetJson} from "../helpers";

export function handleEditableCheckbox(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[editable-checkbox]');
	} else {
		var $cont = $(selector + ' [editable-checkbox]');
	}

	$cont.each(function (idx) {
		let $chbox = $(this);

		$chbox.on('change', function (event) {
			var $el = $(this)

			var changeUrl =
				$el.data('url') +
				'?do=' +
				$el.data('signal') +
				'&field=' +
				$el.data('name') +
				'&value=' +
				$el.prop('checked')

			jqGetJson(changeUrl, function(data) {
				if (typeof data.result != 'undefined' && data.result == false) {
					staticNotification.error(data.errorMessage);
				} else if ($el[0].hasAttribute('ag-update-grid')) {
					updateGridRowData(data)

					if ($el.data('behaviour') === 'default') {
						var $defaultCont = $el.closest('fieldset');
						$defaultCont.find('[data-behaviour="default"][data-name="' + $el.data('name') + '"]').not($el).prop('checked', null);
					}
				} else {
					staticNotification.success('Data úspěšně změněna.');

					if ($el.data('behaviour') === 'default') {
						var $defaultCont = $el.closest('fieldset');
						$defaultCont.find('[data-behaviour="default"][data-name="' + $el.data('name') + '"]').not($el).prop('checked', null);
					}
				}

			})
		});
	});

}

export function handleTableCheckboxes(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('[table-checkboxes] tbody');
	} else {
		var $cont = $(selector + ' [table-checkboxes] tbody');
	}

	$cont.each(function (idx) {
		let $chboxTable = $(this);

		$chboxTable.closest('table').find('thead tr th input[type="checkbox"]').on('change', function (event) {
			let $cbox = $(this)
			if ($cbox.is(':checked')) {
				$chboxTable.checkboxes('check');
			} else {
				$chboxTable.checkboxes('uncheck');
			}
		})

		$chboxTable.checkboxes('range', true);
	});
}
